import { lazy } from 'react'

export const TrackingFrequencyVariant1 = lazy(
  () => import('./TrackingFrequencyVariant1'),
)
